// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumb_container__1XCKl","button":"BreadCrumb_button__1UPJJ","separator":"BreadCrumb_separator__2YfDi"};